import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./Components/ProtectedRoute";
import HomePage from "./Pages/HomePage";
import AdminLayout from "./AdminLayout";
import AdminLoginPage from "./LoginPages/AdminLoginPage";

const App = () => {
  return (
      <Routes>
        {/* PUBLIC */}
        <Route path="/" element={<AdminLoginPage />} />

        {/* PROTECTED ADMIN */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        />
      </Routes>
  );
};

export default App;
